module.exports = __webpack_public_path__ + "img/jqr32.239f8f46.svg";